import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { NotFoundDialogComponent } from '../../find-details/not-found-dialog/not-found-dialog.component';
import { MatIconModule } from '@angular/material/icon';
import { DeafulterListService } from '../../services/raintree/Transmission/deafulter-list.service';
import { response } from 'express';
import { ToastrService } from 'ngx-toastr';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-expired-dialog',
  standalone: true,
  imports: [MatDialogModule, MatIconModule, CommonModule],
  templateUrl: './expired-dialog.component.html',
  styleUrl: './expired-dialog.component.scss'
})
export class ExpiredDialogComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ExpiredDialogComponent>,
    private dialog: MatDialog,
    private defaulterService: DeafulterListService,
    private toaster: ToastrService
  ) {
  }
  ngOnInit(): void {
  }
  onNoClick() {
    this.dialogRef.close(false)
  }
  onYesClick() {
    // this.defaulterService.markAsExpiredInReach(this.data.slNo, { status: 'INACTIVE' }).subscribe({
    //   next: (response: any) => {
    //     console.log(response)
    //   }, error: (error: any) => {
    //     this.toaster.error(error)
    //   }
    // })
    this.dialogRef.close(true)
  }
}
